<template>
     <div>
        <nav class="navbar navbar-expand navbar-light text-white" style="background-image: linear-gradient(to  left, #4682B4, rgb(0,0,0));">
            <ul class="navbar-nav ml-auto">  
                <el-tooltip :content="`Nome: `+ user.nome +` (`+ user.pdescricao +`)`" placement="bottom">
                    <li class="nav-item mt-2 mr-5">
                        <div class="nav-item-link">
                            <img :src="user.avatar" alt="" width="35" class="rounded-circle mr-2 mt-n1">
                            <a style="color: white;" href="/meuperfil/meusdados">{{user.nome}}</a>
                        </div>
                    </li>
                </el-tooltip>
                <!--
                <el-tooltip content="Acessar meus projetos" placement="bottom">
                    <li class="nav-item mt-2 mr-5">
                        <div class="nav-item-link">
                            <i class="fas fa-tasks mr-2"></i>
                            <a href="/painel" class="link">Meus Projetos</a>
                        </div>
                    </li>
                </el-tooltip>
                -->

                <!-- Messages Dropdown Menu -->
                <el-tooltip :content="naoLidas +` Mensagens`" placement="bottom">
                    <li class="nav-item dropdown">
                        <a v-if="naoLidas < 1 " class="nav-link"  href="/mensagem">
                            <i class="fas fa-envelope mr-1 text-white"></i>
                        </a>

                        <a v-if="naoLidas>0" class="nav-link" data-toggle="dropdown" href="#">
                            <i class="fas fa-envelope mr-1 text-white"></i>
                            <span class="badge badge-danger navbar-badge"
                                v-if="naoLidas>0">{{naoLidas}}</span>
                        </a>

                        <div v-if="naoLidas>0" class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
                            <div v-for="msg in listaContato" :key="msg.idmensagem">
                                <a :href="'/mensagem/'+ msg.destinatario.idusuario +'/'+ msg.remetente.idusuario" class="dropdown-item">
                                    <div class="media">
                                        <img :src="msg.remetente.avatar" alt="User Avatar" width="50" class="rounded-circle mt-3 mr-3">
                                        <div class="media-body">
                                            <h3 class="dropdown-item-title">
                                                {{msg.remetente.apelido}}
                                            </h3>
                                            <sup>- {{msg.remetente.perfil}}</sup>
                                            <p class="text-14 mt--1">"{{cortarMensagem(msg.mensagem)}}"</p>
                                            <p class="text-tempo m-0 text-muted"><i class="far fa-clock mr-1"></i> {{msg.tempoDataHora}}</p>
                                        </div>
                                    </div>
                                </a>
                                <div class="dropdown-divider"></div>
                            </div>
                            <a href="/mensagem" class="dropdown-item dropdown-footer">Visualizar mensagens!</a>
                        </div>
                    </li>
                </el-tooltip>
                
                <!-- Notifications Dropdown Menu -->
                <li class="nav-item dropdown">
                    <el-tooltip content="Notificações" placement="bottom">
                        <a class="nav-link" data-toggle="dropdown" href="#">
                            <i class="fas fa-bell mr-1 text-white"></i>
                            <span v-if="listaNotificacao.length > 0" class="badge badge-warning navbar-badge">{{listaNotificacao.length}}</span>
                        </a>
                    </el-tooltip>
                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                        <span class="dropdown-item dropdown-header">{{listaNotificacao.length}} Notificações Novas</span>
                        <div class="dropdown-divider"></div>
                            <a href="/notificacao" class="dropdown-item">
                                <div class="row">
                                    <div class="col-6">
                                        <i class="fas fa-bullseye mr-2"></i> OKR
                                    </div>
                                    <div class="col-6">
                                        <span class="float-right text-muted text-14">{{listaNotificacaoOkr.length}} notificaç{{ (listaNotificacaoOkr.length>1) ? "ões" : "ão" }}</span>
                                    </div>
                                </div>
                            </a>
                        <div class="dropdown-divider"></div>
                            <a href="/notificacao" class="dropdown-item">
                                <div class="row">
                                    <div class="col-6">
                                        <i class="far fa-calendar-check mr-2"></i> Projeto
                                    </div>
                                    <div class="col-6">
                                        <span class="float-right text-muted text-14">{{listaNotificacaoP.length}} notificaç{{ (listaNotificacaoP.length>1) ? "ões" : "ão" }}</span>
                                    </div>
                                </div>
                            </a>
                        <div class="dropdown-divider"></div>
                            <a href="/notificacao" class="dropdown-item">
                                <div class="row">
                                    <div class="col-6">
                                        <i class="fas fa-calendar-check mr-2"></i> Atividade
                                    </div>
                                    <div class="col-6">
                                        <span class="float-right text-muted text-14">{{listaNotificacaoA.length}} notificaç{{ (listaNotificacaoA.length>1) ? "ões" : "ão" }}</span>
                                    </div>
                                </div>
                            </a>
                        <div class="dropdown-divider"></div>
                            <a href="/notificacao" class="dropdown-item">
                                <div class="row">
                                    <div class="col-6">
                                        <i class="far fa-calendar-alt mr-2"></i> Tarefa
                                    </div>
                                    <div class="col-6">
                                        <span class="float-right text-muted text-14">{{listaNotificacaoT.length}} notificaç{{ (listaNotificacaoT.length>1) ? "ões" : "ão" }}</span>
                                    </div>
                                </div>
                            </a>
                        <div class="dropdown-divider"></div>
                            <a href="/notificacao" class="dropdown-item">
                                <div class="row">
                                    <div class="col-6">
                                        <i class="far fa-sticky-note mr-2"></i> Outras
                                    </div>
                                    <div class="col-6">
                                        <span class="float-right text-muted text-14">{{listaNotificacaoO.length}} notificaç{{ (listaNotificacaoO.length>1) ? "ões" : "ão" }}</span>
                                    </div>
                                </div>
                            </a>
                        <div class="dropdown-divider"></div>
                        <a href="/notificacao" class="dropdown-item dropdown-footer">Ver todas notificações</a>
                    </div>
                </li>
            </ul>
            <ul class="navbar-nav" v-if="maisUmPerfil">
                <li class="nav-item">
                    <el-tooltip content="Trocar Perfil" placement="bottom">
                        <a href="#" @click="modalTrocarPerfil" class="nav-link">
                            <i class="fas fa-users-cog mr-1 text-white"></i>
                        </a>
                    </el-tooltip>
                </li>
            </ul>            
            <ul class="navbar-nav">
                <li class="nav-item">
                    <el-tooltip content="Sair" placement="bottom">
                        <a href="#" @click="exitSystem" class="nav-link">
                            <i class="fas fa-door-open mr-1 text-white"></i>
                        </a>
                    </el-tooltip>
                </li>
            </ul>            
        </nav>


        <modal :show.sync="modals.modalPerfil">
            <loader object="#df3e46" v-show="progressPerfil" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            <form class="m-3">
                <h4 class="text-center">Trocar Perfil</h4>
                <div class="mt-3 input-group">
                    <strong>Perfil atual:</strong>&nbsp; {{ perfil.atual }}
                </div>
                <label class="mt-2" for="inputPerfil">
                    Selecionar Perfil
                </label>
                <div class="input-group">
                    <div class="input-group-prepend mb-2">
                        <span class="input-group-text">
                            <i class="fas fa-shield-alt w-14"></i>
                        </span>
                    </div>
                    <v-select
                        id="inputPerfil"
                        class="campoMultiplo mb-2"
                        placeholder="Selecione um Perfil"
                        label="descricao"
                        v-model="perfil.perfil"
                        :options="listaProfileUser">
                        <span slot="no-options" @click="$refs.select.open = false">
                            Nenhum registro encontrado
                        </span>	
                    </v-select>
                </div>
                <br class="clear" />
                <div class="col-md-12 text-center mt-3">
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="fecharModal">
                    Desistir
                </button>
                <button
                    type="button"
                    class="btn btn-primary ml-4"
                    @click="trocarPerfil()">
                    Trocar Perfil
                </button>
                </div>
            </form>
        </modal>

     </div>    
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
    created(){
        this.carregarDadosUsuario(),
        this.verificarMsgNaoLida(),
        this.carregarListaConversa(),
        this.carregarNotificacao()
    },
    data(){
        return {
            naoLidas: 0,
            listaContato: [],
            user : {},
            maisUmPerfil: false,
            progressPerfil: false,
            perfil: {
                atual: "",
                perfil: {},
            },
            modals: {
                modalPerfil: false
            },
            listaProfileUser: [],
            listaNotificacao: [],
            listaNotificacaoOkr: [],
            listaNotificacaoP: [],
            listaNotificacaoA: [],
            listaNotificacaoT: [],
            listaNotificacaoO: []
        }
    },
    methods:{
		carregarNotificacao() {
			this.$clubApi.get("/notificacao/nova").then((response) => {
				this.listaNotificacao = response.data.object;
				this.listaNotificacaoOkr = this.listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 5);
				});
				this.listaNotificacaoP = this.listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 1);
				});
				this.listaNotificacaoA = this.listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 2);
				});
				this.listaNotificacaoT = this.listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 3);
				});
				this.listaNotificacaoO = this.listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 4);
				});
			});
		},
        carregarDadosUsuario(){
            this.user.nome = localStorage.getItem("nome")
            this.user.pid = localStorage.getItem("pid")
            this.user.pdescricao = localStorage.getItem("pdescricao")
            this.user.avatar = localStorage.getItem("avatar")
            this.perfil.atual = this.user.pdescricao;
            this.$clubApi.get("/user/perfil/maisum").then((response) => {
                this.maisUmPerfil = response.data.object;
            });
        },
        modalTrocarPerfil() {
            this.$clubApi.get("/user/lista").then((response) => {
                this.listaProfileUser = [];
                let listaPerfil = response.data.object;
                for (const perfil of listaPerfil) {
                    if (perfil.nome != localStorage.getItem("pnome")) {
                        this.listaProfileUser.push(perfil);
                    }
                }
                this.modals.modalPerfil = true;
            })
            .catch((error) => {
                this.$toastr.error(error.response.data.msg);
            });
        },
        trocarPerfil() {
            if (!this.perfil.perfil.idprofile) {
                this.$toastr.error("Nenhum Perfil selecionado!");
                return;
            }
            if (confirm("Será necessário recarregar a página. Deseja cotinuar?")) {
                this.progressPerfil = true;
                let acesso = { trocaPerfil: this.perfil.perfil.nome };
                this.$clubApi.post("/user/perfil/selecionado", acesso).then((response) => {
                    let retorno = response.data.object;
                    if (retorno == "SEMPERFIL") {
                        this.$toastr.warning("O usuário não tem acesso ao perfil selecionado.");
                    } else {
                        if (retorno != null) {
                            localStorage.setItem("pid", this.perfil.perfil.idprofile);
                            localStorage.setItem("pnome", this.perfil.perfil.nome);
                            localStorage.setItem("pdescricao", this.perfil.perfil.descricao);
                            localStorage.setItem("trocaPerfil", this.perfil.perfil.nome);
                            if (sessionStorage.getItem("token")) {
                                sessionStorage.setItem("token", retorno);
                            } else {
                                localStorage.setItem("token", retorno);
                            }
                            this.modals.modalPerfil = false;
                            location.href = '/'
                        }
                    }
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressPerfil = false;
                });
            }
        },
        fecharModal() {
            this.modals.modalPerfil = false;
        },
        exitSystem(){
            localStorage.removeItem("pid");
            localStorage.removeItem("pnome");
            localStorage.removeItem("pdescricao");
            localStorage.removeItem("profile")
            localStorage.removeItem("token")
            sessionStorage.removeItem("token")
            localStorage.removeItem("trocaPerfil")
            localStorage.removeItem("nome")
            localStorage.removeItem("avatar");
            localStorage.removeItem("idusuario");
            location.href = '/'
        },
        verificarMsgNaoLida() {
            this.$clubApi.get('/mensagem/naolidas').then((response) => {
                this.naoLidas = response.data;
                // TODO: Degabilitado a atualização automática
                setTimeout(() => { this.verificarMsgNaoLida() }, 60000);
            });
        },
		carregarListaConversa() {
			this.$clubApi.get('/mensagem/conversa-topo').then(response => {
				this.listaContato = response.data.object;
			})           
            .catch(error => {
                this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
                // TODO: Degabilitado a atualização automática
                setTimeout(() => this.carregarListaConversa(), 60000);
			});
		},
        cortarMensagem(mensagem) {
            let retorno = mensagem.substring(0, 80);
            let rets = (mensagem.length > 80) ? "..." : "";
            retorno = retorno + rets;
            return retorno;
        }
    }
}   
</script>
<style>
.navbar-light {
    background-color: #f8f9fa;
}
.nav-item-link:hover {
    background-color: #4682B4;
    border-radius: 4px;
    cursor: pointer;
}
.link {
    color:white;
    text-decoration: none;
}
.link:hover {
    color:white;
    text-decoration: none;
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.7);
}
.text-14 {
    font-size: .875rem !important;
}
.text-tempo {
    font-size: 12px !important;
}
.dropdown-item-title {
    font-size: 1rem;
    margin: 0;
}
.dropdown-item:focus, .dropdown-item:hover {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa;
}
.navbar-badge {
    font-size: .6rem;
    font-weight: 300;
    padding: 2px 4px;
    position: absolute;
    right: 5px;
    top: 9px;
}
.dropdown-menu-lg {
    max-width: 300px;
    min-width: 280px;
    padding: 0;
    margin: 0;
    margin-top: 0px;
    white-space: normal;    
}
.dropdown-divider {
    height: 0;
    margin: 0;
    overflow: hidden;
    border-top: 1px solid #e9ecef;
}
.dropdown-footer, .dropdown-header {
    display: block;
    font-size: .875rem;
    padding: .5rem 1rem;
    text-align: center;
}
.campoMultiplo {
  width: 90%;
}
</style>